import { useState, useEffect } from "react";
import { Ticket, ShoppingCart } from "lucide-react";
import api from "../../services/api";

function fmtR(v) { return v == null ? "R$ 0" : "R$ " + v.toLocaleString("pt-BR", { minimumFractionDigits: 2 }); }

export default function DoletasTicketShop({ eligible }) {
  var _gala = useState(null);
  var gala = _gala[0];
  var _myTickets = useState([]);
  var myTickets = _myTickets[0];
  var _buying = useState(false);

  useEffect(function () {
    async function load() {
      try {
        var res = await api.get("/doletas/gala/info");
        _gala[1](res.data);
        var tRes = await api.get("/doletas/gala/my-tickets");
        _myTickets[1](tRes.data.tickets || []);
      } catch (e) {}
    }
    load();
  }, []);

  async function handleBuy(itemName) {
    if (!eligible) {
      alert("Voce precisa de pelo menos 500.000 doletas para participar dos sorteios");
      return;
    }
    _buying[1](true);
    try {
      var res = await api.post("/doletas/gala/buy-ticket", { item_name: itemName, quantity: 1 });
      alert(res.data.message);
      var tRes = await api.get("/doletas/gala/my-tickets");
      _myTickets[1](tRes.data.tickets || []);
      var gRes = await api.get("/doletas/gala/info");
      _gala[1](gRes.data);
    } catch (err) {
      alert("Erro: " + (err.response?.data?.detail || err.message));
    } finally {
      _buying[1](false);
    }
  }

  if (!gala) return null;
  var items = gala.raffle_items || [];
  if (items.length === 0) return null;

  var itemCards = [];
  for (var i = 0; i < items.length; i++) {
    var item = items[i];
    itemCards.push(
      <div key={item.name} className="border border-gray-200 rounded-xl p-4 flex flex-col" data-testid={"raffle-item-" + i}>
        <div className="flex items-center gap-2 mb-2">
          <Ticket className="w-4 h-4 text-[#F26A4B]" />
          <span className="text-sm font-medium text-[#0A2F3D] flex-1">{item.name}</span>
        </div>
        <p className="text-lg font-bold text-[#0A2F3D]">{fmtR(item.ticket_price)}</p>
        <p className="text-xs text-gray-400 mb-3">{item.tickets_sold || 0} ticket(s) vendido(s)</p>
        <button
          onClick={function () { var n = item.name; handleBuy(n); }}
          disabled={_buying[0] || !eligible}
          className={"mt-auto flex items-center justify-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors " +
            (eligible ? "bg-[#F26A4B] hover:bg-[#E05A3B] text-white" : "bg-gray-100 text-gray-400 cursor-not-allowed")}
          data-testid={"btn-buy-" + i}
        >
          <ShoppingCart className="w-4 h-4" />{eligible ? "Comprar" : "Min. 500k doletas"}
        </button>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-4 lg:p-5 mb-4" data-testid="ticket-shop">
      <div className="flex items-center gap-2 mb-4">
        <Ticket className="w-5 h-5 text-[#F26A4B]" />
        <h4 className="font-semibold text-[#0A2F3D] text-sm">Sorteios - Compre seus Tickets</h4>
      </div>
      {!eligible && (
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 mb-4">
          <p className="text-xs text-amber-700">Acumule pelo menos 500.000 doletas para participar dos sorteios da Noite de Gala.</p>
        </div>
      )}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">{itemCards}</div>

      {/* My Tickets */}
      {myTickets.length > 0 && (
        <div className="mt-4 pt-4 border-t border-gray-100">
          <h4 className="text-xs font-medium text-gray-500 mb-2">Meus Tickets ({myTickets.length})</h4>
          <div className="flex flex-wrap gap-2">
            {myTickets.map(function (t) {
              return (
                <div key={t.id} className="bg-gray-50 border border-gray-200 rounded-lg px-3 py-2 text-xs" data-testid={"my-ticket-" + t.id}>
                  <span className="font-mono text-[#3B82F6]">{t.ticket_number}</span>
                  <span className="text-gray-400 ml-2">{t.item_name}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
